<template>
    <div>
        <myPage :max_flag="true">
            <div class="flex-box nopadding wrap pd-left5 pd-bottom5" slot="header">
                <el-button-group class="mg-right5 mg-top5 flex-box nopadding">
                    <el-button size="small" :title="$t('refs')" icon="el-icon-refresh" @click="list()"></el-button>
                    <el-button size="small" @click="exportExcel" :title="$t('export')" icon="el-icon-download"></el-button>
                </el-button-group>
                <div class="f-bd f14 text-nowrap">账期{{$t('x_mh')}}</div>
                <div class="mg-right5 mg-top5"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right5 mg-top5" v-if="mod_cat != 'M3'">
                    <el-input class="width-300" size="small" v-model="search.org_cname">
                        <span slot="prepend">客户名称：</span>
                    </el-input>
                </div>
                <div class="mg-top5"><el-button size="small" @click="list(false)">{{$t('list')}}</el-button></div>
            </div>
            <div class="fillw fillh">
                <el-table :data="listData" class="fillw show-scroll" height="100%">
                    <el-table-column fixed prop="org_cname" :label="listHeader.org_cname" min-width="150px"></el-table-column>
                    <el-table-column :label="listHeader.start_cat20_qty" min-width="140px">
                        <template slot-scope="scope">{{scope.row.start_cat20_qty * 1}}</template>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat20_qty10">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat20_qty10 * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat20_qty10 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat20_qty11">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat20_qty11 * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat20_qty11 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat20_qty12">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat20_qty12 * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat20_qty12 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat20_qty13">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat20_qty13 * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat20_qty13 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat20_qty20">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div slot-scope="scope" slot="header" class="f-blue">{{totalData.sum.mv_cat20_qty20 * 1}}</div>
                            <div class="f-bd f-blue" slot-scope="scope">{{scope.row.mv_cat20_qty20 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat20_qty21">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div slot-scope="scope" slot="header" class="f-blue">{{totalData.sum.mv_cat20_qty21 * 1}}</div>
                            <div class="f-bd f-blue" slot-scope="scope">{{scope.row.mv_cat20_qty21 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat20_qty_other">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat20_qty_other * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat20_qty_other * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.end_cat20_qty" min-width="140px">
                        <template slot-scope="scope">{{scope.row.end_cat20_qty * 1}}</template>
                    </el-table-column>
                    <el-table-column :label="listHeader.start_cat10_qty" min-width="140px">
                        <template slot-scope="scope">{{scope.row.start_cat10_qty * 1}}</template>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat10_qty10">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat10_qty10 * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat10_qty10 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat10_qty11">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat10_qty11 * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat10_qty11 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat10_qty12">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat10_qty12 * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat10_qty12 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat10_qty13">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat10_qty13 * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat10_qty13 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat10_qty20">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div slot-scope="scope" slot="header" class="f-blue">{{totalData.sum.mv_cat10_qty20 * 1}}</div>
                            <div class="f-bd f-blue" slot-scope="scope">{{scope.row.mv_cat10_qty20 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat10_qty21">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <div slot-scope="scope" slot="header" class="f-blue">{{totalData.sum.mv_cat10_qty21 * 1}}</div>
                            <div class="f-bd f-blue" slot-scope="scope">{{scope.row.mv_cat10_qty21 * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.mv_cat10_qty_other">
                        <el-table-column label-class-name="f-red pd-top0" min-width="140px">
                            <template slot-scope="scope" slot="header">{{totalData.sum.mv_cat10_qty_other * 1}}</template>
                            <div class="f-bd f-red" slot-scope="scope">{{scope.row.mv_cat10_qty_other * 1}}</div>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column :label="listHeader.end_cat10_qty" min-width="140px">
                        <template slot-scope="scope">{{scope.row.end_cat10_qty * 1}}</template>
                    </el-table-column>
                    <el-table-column :label="listHeader.date_no" prop="date_no" width="220px"></el-table-column>
                    <el-table-column :label="listHeader.upd_time" prop="upd_time" width="160px"></el-table-column>
                </el-table>
            </div>
            <div slot="footer">
                <myPager slot="footer" :limit="search.limit" @onLimitChange="onLimitChange"
                         v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
            </div>
        </myPage>
        <myDrawer v-model="show_subview">
            <router-view></router-view>
        </myDrawer>
    </div>
</template>

<script>
import myPager from '../../../components/myPager'
import myDatePicker from '../../../components/myDatePicker'
import excel from '../../../utils/excel'
export default {
    name:'r3-orgcrsum', //文件名称
    components:{
        myPager,
        myDatePicker,
    },
    data: function(){
        const listHeader = {
            org_cname: "客户",
            start_cat20_qty: "期初余额(面额)",//数字模式
            mv_cat20_qty10: "入驻设置(面额)",//汇总模式
            mv_cat20_qty11: "人工增额(面额)",//汇总模式
            mv_cat20_qty12: "下单失败返还(面额)",//汇总模式
            mv_cat20_qty13: " 每日恢复(面额)",//汇总模式
            mv_cat20_qty20: "正常消费(面额)",//汇总模式
            mv_cat20_qty21: "人工减额(面额)",//汇总模式
            mv_cat20_qty_other: "其他(面额)",//汇总模式
            end_cat20_qty: "期末余额(面额)",//数字模式
            start_cat10_qty: "期初余额(单量)",//数字模式
            mv_cat10_qty10: "入驻设置(单量)",//汇总模式
            mv_cat10_qty11: "人工增额(单量)",//汇总模式
            mv_cat10_qty12: "下单失败返还(单量)",//汇总模式
            mv_cat10_qty13: " 每日恢复(单量)",//汇总模式
            mv_cat10_qty20: "正常消费(单量)",//汇总模式
            mv_cat10_qty21: "人工减额(单量)",//汇总模式
            mv_cat10_qty_other: "其他(单量)",//汇总模式
            end_cat10_qty: "期末余额(单量)",//数字模式
            date_no: "账期",
            upd_time: "结算时间"
        }
        return{
            relist: false,
            show_subview: false,
            mod_cat: this.$base.getModCat(),
            search:{
                search_url: 'report-cr-sum/list', //r3-day 为文件名称
                datearea_id:7,//如果大于0 mounted 要删除date_fr date_to
                date_fr: '',
                date_to: '',
                page: 1,
                pageSize: 0,
                limit:'30',
                org_cname:''
            },
            listHeader,//表结构
            listData:[],
            totalData: {
                total: 0,//总行数
                sum:{}
            },
        }
    },
    activated:function(){
        this.$base.setMenuOpens();
    },
    mounted:function(){
        this.$base.setMenuOpens();

        this.$base.listPageInit(this,()=>{
            this.list();
        });
    },
    methods: {
        onDateChange: function(data){
            this.search.date_fr = data[0];
            this.search.date_to = data[1];
        },
        onPagerChange: function () {
            this.list(true);
        },
        onLimitChange: function (limit) {
            this.search.limit = limit;
            this.list();
        },
        list: function (change_page) {
            this.$base.list(this, change_page);
        },
        exportExcel: function(){
            // this.$base.exportExcel(this);
            excel.exportExcel(this);
        }
    },
    watch:{
        //界面重新加载数据
        relist:function (newVal,oldVal) {
            if(newVal){
                this.list(true);
                this.relist = false;
            }
        }
    }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/report/orgcrsum/list.vue